module.exports = __webpack_public_path__ + "img/探索星座.5ebb2e95.svg";